/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_TitleInputs */

const en_mk_mx_title = /** @type {(inputs: Mk_Mx_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you get in each plan`)
};

const id_mk_mx_title = /** @type {(inputs: Mk_Mx_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang Anda dapat di tiap paket`)
};

/**
* | output |
* | --- |
* | "What you get in each plan" |
*
* @param {Mk_Mx_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_title = /** @type {((inputs?: Mk_Mx_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_title(inputs)
	return en_mk_mx_title(inputs)
});